import SvgIcon, { SvgIconProps } from "@material-ui/core/SvgIcon";
import * as React from "react";

export const PlayIcon = (props: SvgIconProps) => {
    const { viewBox = "-5 -4 20 20", ...rest } = props;

    return (
        <SvgIcon data-cy="playIcon" viewBox={viewBox} {...rest}>
            <g fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
                <g fill="#21006E" transform="translate(-72 -14)">
                    <g transform="translate(56)">
                        <path
                            d="M21.4285714 16.1904762L27.6190476 25.2698413 15.2380952 25.2698413z"
                            transform="rotate(90 21.429 20.73)"
                        ></path>
                    </g>
                </g>
            </g>
        </SvgIcon>
    );
};
